import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { UserFriend } from "@/modules/users/viewmodels/UserFriend";

export const state = {
  userFriends: [],
};

export const getters = Object.assign(
  {
    userFriends: (state) => {
      return state.userFriends;
    },
    userFriend: (state) => (Id) => {
      return state.userFriends.find((e) => e.id === Id);
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/users-friends",
    UserFriend,
    {
      AfterShow: (name, data) => {
        let el = state.userFriends.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.userFriends.push(data);
        }
        return data;
      },
      AfterDestroy: (name, data) => {
        let element = state.userFriends.find((e) => e.id === data);

        state.userFriends.splice(
          state.userFriends.findIndex((e) => e.id === data),
          1
        );

        return data;
      },
    },
    {
      /**
       * Connect multiple users with each other
       * this.$store.getters['userfriend/api'].Custom.Connect(UserIds)
       */
      Connect: async (UserIds) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/user-friends/connect",
          {
            ids: UserIds ? UserIds : [],
          }
        );

        return ApiResult.data;
      },
      /**
       * Update the notes for a given friendship
       * this.$store.getters['userfriend/api'].Custom.UpdateNotes(FriendId, Notes)
       */
      UpdateNotes: async (FriendId, Notes) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.put(
          process.env.VUE_APP_BASE_URL +
            "/api/user-friends/" +
            FriendId +
            "/notes",
          {
            notes: Notes ? Notes : "",
          }
        );

        return ApiResult.data;
      },
      /**
       * Returns all my friends
       * this.$store.getters['userfriend/api'].Custom.My()
       */
      My: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/users-friends/my",
          {}
        );

        let data = ApiResult.data.data.map((Entry) => {
          return new UserFriend(Entry);
        });

        data.forEach((e) => {
          let foundElement = state.userFriends.find((a) => a.id === e.id);
          if (foundElement) {
            Object.assign(foundElement, e);
          } else {
            state.userFriends.push(e);
          }
        });

        return data;
      },

      /**
       * Returns my newest friendships of last week
       * this.$store.getters['userfriend/api'].Custom.LastWeek()
       */
      LastWeek: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/users-friends/lastweek",
          {}
        );

        let data = ApiResult.data.data.map((Entry) => {
          return new UserFriend(Entry);
        });

        return data;
      },

      /**
       * Returns all my friends
       * this.$store.getters['userfriend/api'].Custom.IsFriend(FriendId)
       */
      IsFriend: async (FriendId) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL +
            "/api/users-friends/" +
            FriendId +
            "/isfriend",
          {}
        );

        return ApiResult.data.data;
      },

      /**
       * Returns friendship for FriendId
       * this.$store.getters['userfriend/api'].Custom.FriendFriendship(FriendId)
       */
      FriendFriendship: async (FriendId) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL +
            "/api/users-friends/" +
            FriendId +
            "/findfriendfriendship",
          {}
        );

        let data = new UserFriend(ApiResult.data.data);

        return data;
      },
    }
  )
);

// mutations
export const mutations = {};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/users-friends",
  [],
  {}
);
